import React, { HTMLAttributes, PropsWithChildren } from 'react';

import styles from './pill.module.css';

type PillProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    borderRadius?: string;
    borderWidth?: string;
    borderStyle?: React.CSSProperties['borderStyle'];
    borderColor?: string;
    /** backgroundColor doesn't work when colorMix is set */
    backgroundColor?: string;
    padding?: string;
    width?: string;
    height?: string;
    colorMix?: {
      color: string;
      mix: string;
    };
    borderMix?: {
      color: string;
      mix: string;
    };
    textColor?: string;
  }
>;

const Pill = ({
  children,
  width,
  height,
  className,
  colorMix,
  borderMix,
  borderRadius,
  padding,
  style,
  borderStyle = 'solid',
  borderWidth,
  borderColor,
  textColor,
  backgroundColor,
  ...rest
}: PillProps) => {
  return (
    <div
      className={`${styles.container} ${className} ${borderWidth ? styles.hasBorder : ''} ${borderMix ? styles.hasBorderMix : ''} ${textColor ? styles.hasTextColor : ''} ${!colorMix?.color && backgroundColor ? styles.hasBackgroundColor : ''}`}
      style={{
        ...(borderRadius && { '--pill-radius': borderRadius }),
        ...(padding && { '--pill-padding': padding }),
        ...(colorMix && { '--pill-color': colorMix.color, '--pill-mix': colorMix.mix }),
        ...(width && { '--pill-width': width }),
        ...(height && { '--pill-height': height }),
        ...(borderStyle && { '--pill-border-style': borderStyle }),
        ...(borderWidth && { '--pill-border-width': borderWidth }),
        ...(borderColor && { '--pill-border-color': borderColor }),
        ...(textColor && { '--pill-text-color': textColor }),
        ...(backgroundColor && { '--pill-background-color': backgroundColor }),
        ...(borderMix && { '--pill-border-mix': borderMix.mix, '--pill-border-color': borderMix.color }),
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Pill;
